<template>
  <Dialog as="div" class="relative z-10" :open="true" @close="$emit('close')">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-50"/>

    <div class="fixed inset-0 overflow-hidden">
      <div class="absolute inset-0 overflow-hidden">
        <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
          <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                           enter-from="translate-x-full" enter-to="translate-x-0"
                           leave="transform transition ease-in-out duration-500 sm:duration-700"
                           leave-from="translate-x-0" leave-to="translate-x-full">
            <DialogPanel class="pointer-events-auto w-screen max-w-md">
              <form class="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl" @submit.prevent="postNow">
                <div class="h-0 flex-1 overflow-y-auto">
                  <div class="bg-indigo-700 px-4 py-6 sm:px-6">
                    <div class="flex items-center justify-between">
                      <DialogTitle class="text-base font-semibold leading-6 text-white">Nouveau fournisseur
                      </DialogTitle>
                      <div class="ml-3 flex h-7 items-center">
                        <button type="button" @click="$emit('close')"
                                class="relative rounded-md bg-indigo-700 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white">
                          <span class="absolute -inset-2.5"/>
                          <span class="sr-only">Fermer</span>
                          ✕
                        </button>
                      </div>
                    </div>
                    <div class="mt-1">
                      <p class="text-sm text-indigo-300">Le fournisseur sera enrichi automatiquement : registre TVA
                        (VIES/HMRC), logo, site, description.</p>
                    </div>
                  </div>
                  <div class="flex flex-1 flex-col justify-between">
                    <div class="divide-y divide-gray-200 px-4 sm:px-6">
                      <div class="space-y-6 pb-5 pt-6">
                        <div>
                          <label for="company-name" class="block text-sm font-medium leading-6 text-gray-900">
                            Nom <span class="text-red-500">*</span>
                          </label>
                          <div class="mt-2">
                            <input type="text" id="company-name" v-model="form.name" required
                                   placeholder="OVH"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                        </div>
                        <div>
                          <label for="company-website" class="block text-sm font-medium leading-6 text-gray-900">
                            Site web <span class="text-gray-400">(optionnel)</span>
                          </label>
                          <div class="mt-2">
                            <input type="text" id="company-website" v-model="form.website"
                                   placeholder="ovh.com"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                        </div>
                        <div>
                          <label for="company-vat" class="block text-sm font-medium leading-6 text-gray-900">
                            Numéro de TVA <span class="text-gray-400">(optionnel)</span>
                          </label>
                          <div class="mt-2">
                            <input type="text" id="company-vat" v-model="form.company_registration"
                                   placeholder="FR22424761419"
                                   class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                          </div>
                          <p class="mt-1 text-xs text-gray-500">Utilisé pour récupérer le nom légal et l'adresse
                            officielle, et éviter les doublons.</p>
                        </div>

                        <div v-if="result" class="rounded-md p-4"
                             :class="result.already_exists ? 'bg-amber-50' : 'bg-emerald-50'">
                          <div class="flex items-center">
                            <img v-if="result.company.avatar" :src="result.company.avatar"
                                 class="h-10 w-10 rounded-full mr-3" alt=""/>
                            <div>
                              <p class="text-sm font-semibold"
                                 :class="result.already_exists ? 'text-amber-800' : 'text-emerald-800'">
                                {{ result.already_exists ? 'Ce fournisseur existe déjà' : 'Fournisseur créé' }}
                              </p>
                              <p class="text-sm text-gray-700">{{ result.company.name }}</p>
                              <p v-if="result.company.website" class="text-xs text-gray-500">
                                {{ result.company.website }}
                                <span v-if="result.company.company_registration"> — {{ result.company.company_registration }}</span>
                              </p>
                            </div>
                          </div>
                        </div>

                        <div v-if="error" class="rounded-md bg-red-50 p-4">
                          <p class="text-sm text-red-700">{{ error }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex flex-shrink-0 justify-end px-4 py-4">
                  <button type="button" @click="$emit('close')"
                          class="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                    Fermer
                  </button>
                  <button type="submit" :disabled="isSaving || !form.name"
                          :class="[isSaving || !form.name ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500', 'ml-4 inline-flex justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600']">
                    {{ isSaving ? 'Enrichissement…' : 'Créer' }}
                  </button>
                </div>
              </form>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {Dialog, DialogPanel, DialogTitle, TransitionChild} from '@headlessui/vue'
</script>

<script>
import {usePost} from "@/composables/fetch";

export default {
  emits: ['close', 'created'],
  data() {
    return {
      form: {
        name: '',
        website: '',
        company_registration: '',
      },
      result: null,
      error: null,
      isSaving: false,
    }
  },
  methods: {
    async postNow() {
      if (!this.form.name || this.isSaving) {
        return;
      }

      this.isSaving = true;
      this.result = null;
      this.error = null;

      try {
        const token = await this.$auth.getAccessTokenSilently();
        const response = await usePost('company', {
          name: this.form.name,
          website: this.form.website || null,
          company_registration: this.form.company_registration || null,
        }, token);

        if (response && response.data && response.data.company) {
          this.result = response.data;
          this.$emit('created', response.data.company);
        } else {
          this.error = "Impossible de créer le fournisseur.";
        }
      } catch (e) {
        this.error = e?.response?.data?.message || "Erreur lors de la création.";
      }

      this.isSaving = false;
    },
  },
}
</script>
